import styled from "styled-components";

export const Container = styled.div`
  font-family: "Poppins", sans-serif;
  display: block;
  max-height: 335px;
`;

export const FieldsContainer = styled(Container)`
  width: 158px;
`;

export const ContainerTitle = styled.div`
  display: flex;
  margin-bottom: 7px;
  color: ${({ theme }) => theme.darkBlueBackground};
  font-size: 17px;
  font-weight: 600;
  cursor: pointer;
`;

export const ContainerTitleChevron = styled.span<{ onClick: Function }>`
  display: flex;
  align-items: center;
  max-width: 90vw;

  & > span:nth-child(2) {
    margin-right: 15px;
  }
`;

export const Chevron = styled.span<{ toggleClosed: boolean }>`
  margin-top: ${props => (props.toggleClosed ? "-5px" : "5px")};
  margin-left: 25px;
  border: solid ${({ theme }) => theme.darkBlueBackground};
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 4px;
  transform: ${props => (props.toggleClosed ? "rotate(45deg)" : "rotate(-135deg)")};
`;

export const ContainerCollapsable = styled.div<{ isVisible: boolean }>`
  display: ${props => props.isVisible ? "flex" : "none"};
  justify-content: space-between;
  overflow: ${props => props.isVisible ? "visible" : "hidden"};
  padding-right: 77px;
  margin-bottom: 20px;
`;

export const VerticalLine = styled.div`
  border-left: 2px solid #AFAFAF;
  margin-bottom: 3px;
`;

export const HelperLine = styled.div`
  display: flex;
  color: #808080;
  font-size: 12px;
  font-weight: 600;
  margin-top: 10px;
  white-space: nowrap;
`;
